import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import IconNewRecord from "src/assets/images/icon_newrecord.svg";
import IconDownload from "src/assets/images/icon_download.svg";
import Modal from "@mui/material/Modal";
import { Box, Button, Pagination, Checkbox, InputLabel } from "@mui/material";
import { ProjectManagerDispatchTable } from "src/helpers/Tables/projectManagerDispatchTable";
import { DispatchForm } from "./add";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";
import { toast } from "react-toastify";
import { GetError, convertIsoToLocalDateTime } from "src/constant";
import { getAllDispatchOrderData } from "src/thunks/dispatchOrder";
import _ from "lodash";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "46%",
  transform: "translate(-50%, -50%)",
  width: "77%",
  height: "100%",
  bgcolor: "background.paper",
  overflowY: "scroll",
};

const ProjectManagerDispatchOrderList = () => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const { isDropdownOpenFlagValue } = useSelector((state) => state.dashboard);
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);
  const { allDispatchOrderData } = useSelector((state) => state.dispatch);
  const { filterAllData } = useSelector((state) => state.goodsin);
  
  /** hooks useState ----------------------------------------------------- **/
  const [open, setOpen] = React.useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isDelivery, setIsDelivery] = useState(null);
  const [isCollection, setIsCollection] = useState(null);
  
  /** Variable declarations ----------------------------------------------------- **/
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const filterData = filterAllData["dispatch"];
  const orderedClientList = _.orderBy(userDetails?.projects, ['clientName'], ["asc"])
  let pageSize = 1000;

  /** hooks useEffect ------------------------------------------------------------- */
  useEffect(() => {
    getDispatchOrderDataFunc(currentPage, isDelivery, isCollection);
  }, [currentPage, isDelivery, isCollection]);

  /** handler functions--------------------------------------------------- **/
  const handleClose = () => setOpen(false);

  const getDispatchOrderDataFunc = async (page, deliveryType, collectionType) => {
    try {
      let data = {
        isDateRange: false,
        from: moment(filterData?.fromDate).format("YYYY-MM-DD"),
        DepotIds: [filterData?.depotId?.id || 0],
        ClientIds: [filterData?.clientId?.id || 0],
        ProjectIds: [filterData?.projectId?.id || 0],
        currentPage: page,
        typeId: deliveryType ? 19 : collectionType ? 20 : "",
      };
      if (filterData?.toDate) {
        data["isDateRange"] = true;
        data["to"] = moment(filterData?.toDate).format("YYYY-MM-DD");
      }
      await dispatch(getAllDispatchOrderData({ ...data })).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  const saveExcelFile = (
    tableData,
    dateFromStr,
    dateToStr,
    clientStr,
    projectStr
  ) => {
    const worksheet = XLSX.utils.aoa_to_sheet([
      ["Date:", `${moment(dateFromStr).format("DD-MMM-YYYY")}  ${dateToStr ? "To  " + moment(dateToStr).format("DD-MMM-YYYY") : ""}`],
      ["Client:", clientStr || "All Client"],
      ["Project:", projectStr?.name || "All Project"],
      [],
      [],
      [
        "DUE/PICK UP",
        "ORDER NUMBER",
        "PROJECT",
        "DEPOT",
        "RAISED",
        "STATUS",
        "ITEMS",
        "INTERNAL",
        "EXTERNAL",
        "VEHICLES",
        "DEPOT MANAGER",
      ],
      ...tableData.map((row) => {
        return [
          convertIsoToLocalDateTime(`${row?.dueDate}.00Z`, "DD-MMM-YYYY HH:mm"),
          row?.orderNo,
          row?.projectName,
          row?.depotCode,
          row.raisedOn ? moment(row?.raisedOn).format("DD-MMM-YYYY HH:mm") : "",
          row.statusValue,
          row?.itemCount + "of" + row?.dispatchItemCount,
          row.statusValue === "Pending" || row.statusValue === "Review" ? "--" : row?.interiorSpace || 0,
          row.statusValue === "Pending" || row.statusValue === "Review" ? "--" : row?.exteriorSpace || 0,
          row?.vehicles || 0,
          row.statusValue === "Pending" || row.statusValue === "Review" ? "--" : row?.depotManager,
        ];
      }),
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    // Generate the Excel file buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Convert buffer to Blob and save the file
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const customFileName = `Dispatch Data ${moment().format(
      "DD:MMM:YYYY:HH:mm"
    )}.xlsx`;
    saveAs(data, customFileName);
  };

  const Print = () => {
    const client = filterData?.clientId?.name;
    const project = filterData?.projectId;
    saveExcelFile(
      allDispatchOrderData,
      filterData?.fromDate,
      filterData?.toDate,
      client,
      project
    );
  };

  const handleChange = (event, value) => {
    setCurrentPage(value); // Update the page when the user clicks on a pagination button
  };

  return (
    <>
      <div
        className={`${isDropdownOpenFlagValue == true || signoutModelOpenFlag == true
          ? "add-overlay-for-depot-dropdown"
          : ""
          } main-goods-in-tab-div d-flex flex-column ms-3 me-3`}
      >
        <div className="container-fluid p-0">
          <div className="row mt-2 justify-content-center justify-content-md-end g-0">
            <div className="col-6 col-md-3 col-lg-2 show-goodsin-review-checkbox d-flex ">
              <Checkbox
                checked={isDelivery}
                onChange={({ target }) => {
                  setCurrentPage(1);
                  setIsDelivery(target.checked);
                  setIsCollection(false);
                }}
              />
              <InputLabel>DELIVERIES ONLY</InputLabel>
            </div>
            <div className="col-6 col-md-3 col-lg-3 show-goodsin-review-checkbox d-flex ">
              <Checkbox
                checked={isCollection}
                onChange={({ target }) => {
                  setCurrentPage(1);
                  setIsCollection(target.checked);
                  setIsDelivery(false);
                }}
              />
              <InputLabel>COLLECTIONS ONLY</InputLabel>
            </div>
          </div>
        </div>

        <ProjectManagerDispatchTable
          allDispatchTableData={allDispatchOrderData}
        />
        <div
          style={{ height: 60 }}
          className="d-flex flex-row justify-content-between align-items-center"
        >
          <div className="d-flex">
            {allDispatchOrderData?.totalPages > 1 && (
              <Pagination
                count={Math.ceil(allDispatchOrderData?.totalItems / pageSize)}
                page={currentPage}
                onChange={handleChange}
                variant="outlined"
                color="primary"
              />
            )}
          </div>
          <div className="d-flex">
            <Button
              variant="outlined"
              className="goodsin-list-btns-style ms-2"
              startIcon={
                <img src={IconNewRecord} width={17} height={17} alt="new"></img>
              }
              type="submit"
              onClick={() => setOpen(!open)}
            >
              ADD NEW ORDER
            </Button>
            <Button
              disabled={
                allDispatchOrderData?.length <= 0 ? true : false
              }
              variant="outlined"
              className={`save-report-btn-style ms-2  ${allDispatchOrderData?.length <= 0 ? "fade-out" : ""
                }`}
              startIcon={
                <img src={IconDownload} width={17} height={17} alt="new"></img>
              }
              type="submit"
              onClick={() => Print()}
            >
              Save Report
            </Button>
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <div className="depot-form-header-style ps-4">ADD DELIVERY ORDER</div>
          <DispatchForm
            handleClose={handleClose}
            getAllDispatchData={getDispatchOrderDataFunc}
            currentPage={currentPage}
            isDelivery={isDelivery}
            isCollection={isCollection}
          />
        </Box>
      </Modal>
    </>
  );
};
export default ProjectManagerDispatchOrderList;
